import {
    Box,
    Button,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    List,
    ListItem,
    ListSubheader,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { InputLabel } from "@mui/material";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { send } from "../../SendRequest";
import { isObjectNotEmpty } from "../../Utils";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import YesNoUnbindIamsmartDialog from "../../component/YesNoDialog/YesNoUnbindIamsmartDialog";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import {
    resetApplicantFormList,
    resetProfile,
    resetToken,
} from "../../redux/action";
import { getSelectedUserOrg, getUserRole } from "../../redux/selector";
import { useAuth } from "../AuthContext/AuthContext";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function ProfilePage() {
    let navigate = useNavigate();
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const [userName, setUserName] = useState("");
    const [post, setPost] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [showUnLinkButton, setShowUnLinkButton] = useState(false);
    const [openid, setOpenid] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenUnlink, setIsOpenUnlink] = useState(false);
    const [updated, setUpdated] = useState(false);
    const role = useSelector(getUserRole());
    const [fetched, setFetched] = useState(false);
    const selectedUserOrg = useSelector(getSelectedUserOrg());
    const dispatch = useDispatch();
    const handleSavedClose = () => {
        setIsOpen(false);
    };

    const [cookies, setCookie, removeCookie] = useCookies(["token"]);

    const [yesNoOpen, setYesNoOpen] = useState(false);

    const handleYesOrNoDailogOpen = () => {
        setYesNoOpen(true);
    };

    const handleYesOrNoDailogClose = () => {
        setYesNoOpen(false);
    };

    const handleYes = () => {
        onUnLinkIamSmart();
        handleLogout();
        handleYesOrNoDailogClose();
    };

    const handleNo = () => {
        handleYesOrNoDailogClose();
    };

    function SavedDialog(isOpen) {
        return (
            <React.Fragment>
                <Dialog aria-labelledby="simple-dialog-title" open={isOpen}>
                    <DialogTitle
                        id="simple-dialog-title"
                        style={{ textAlign: "center" }}
                    >
                        {t("common.portal.savedSuccessfully")}
                    </DialogTitle>
                    <DialogContent style={{ textAlign: "center" }}>
                        {t("common.portal.changesSaved")}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={handleSavedClose}
                            color="success"
                        >
                            <b>{t("common.portal.confirm")}</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }

    const onSubmit = () => {
        console.log("submitted:" + userName + " " + post);
        const updatedData = {
            name: userName,
            post: post,
            scrn: selectedUserOrg.scrn,
        };
        const option = {
            url: `${Config.CONTENT_PATH}/users/setProfile`,
            method: "PUT",
            body: JSON.stringify(updatedData),
        };
        dispatch(send("SET_USER_PROFILE", option))
            .then((response) => response.json())
            .then((result) => {
                console.log("result: ", result);
                setUserName(result.name);
                setUserEmail(result.email);
                setPost(result.post);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
                // setRefresh({});
            });
        setIsOpen(true);
    };

    const { setIsChangingPassword } = useAuth();

    const handleLogout = () => {
        if (
            navigator.userAgent.includes("iAM Smart In-App Browser") &&
            window.eIDJSBridge
        ) {
            // Clean up all authentication data before closing In-App Browser
            window.eIDJSBridge.closeInAppBrowser();
        } else {
            removeCookie("token", {
                path: `${Config.CONTENT_PATH}`,
            });
            dispatch(resetToken());
            dispatch(resetProfile());
            dispatch(resetApplicantFormList());
            var self = window.self;
            self.opener = window.self;
            self.close();
            navigate("/Login");
            setIsChangingPassword(false);
        }
    };

    const onUnLinkIamSmart = () => {
        console.log("unLinkIamSmart:" + userName + " " + openid);
        const updatedData = {
            name: userName,
            scrn: selectedUserOrg.scrn,
            openid: "",
        };
        const option = {
            url: `${Config.CONTENT_PATH}/users/unLinkIamSmart`,
            method: "PUT",
            body: JSON.stringify(updatedData),
        };
        dispatch(send("UN_LINK_IMASMART", option))
            .then((response) => response.json())
            .then((result) => {
                console.log("unlink result: ", result);
                setUserName(result.name);
                setUserEmail(result.email);
                setPost(result.post);
                setOpenid("");
                setShowUnLinkButton(false);
            })
            .catch((error) => {
                console.log("fetch error: ", error);
                // setRefresh({});
            });
    };

    useEffect(() => {
        if (isObjectNotEmpty(selectedUserOrg)) {
            setPost(selectedUserOrg.post);
            setUpdated(!updated);
            const userData = { scrn: selectedUserOrg.scrn };
            const option = {
                url: `${Config.CONTENT_PATH}/users/profile`,
                method: "POST",
                body: JSON.stringify(userData),
            };
            dispatch(send("GET_USER_PROFILE", option))
                .then((response) => response.json())
                .then((result) => {
                    console.log("result: ", result);
                    setUserName(result.name);
                    setUserEmail(result.email);
                    setPost(result.post);
                    if (isObjectNotEmpty(result?.openid)) {
                        setShowUnLinkButton(true);
                        setOpenid(result?.openid);
                    }
                    setFetched(true);
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        }
    }, [selectedUserOrg]);
    console.log("Post:" + post);
    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.profilePage")}
                className="header"
            ></Header>
            <Box className="container">
                <YesNoUnbindIamsmartDialog
                    open={yesNoOpen}
                    onClose={handleYesOrNoDailogClose}
                    onYes={handleYes}
                    onNo={handleNo}
                />
                <PortalNavbar aside className="drawer" />
                {fetched == true && (
                    <main className="main">
                        <List
                            sx={{
                                width: "100%",
                                maxWidth: 360,
                                bgcolor: "background.paper",
                                p: 2,
                            }}
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            subheader={
                                <ListSubheader
                                    component="div"
                                    id="nested-list-subheader"
                                >
                                    {t("common.portal.about")}
                                </ListSubheader>
                            }
                        >
                            <List style={{ padding: 0 }}>
                                <ListItem>
                                    <Typography
                                        style={
                                            i18n.language === "en"
                                                ? { width: "3.8rem" }
                                                : { width: "3rem" }
                                        }
                                    >
                                        <InputLabel htmlFor="username">
                                            {t("common.portal.name")}: &nbsp;
                                        </InputLabel>
                                    </Typography>
                                    <CustomTextField
                                        style={{ width: "40%" }}
                                        defaultValue={userName}
                                        onChange={(e) =>
                                            setUserName(e.target.value)
                                        }
                                        id="username"
                                        inputProps={{
                                            readOnly:
                                                role == "SA" ||
                                                role == "E" ||
                                                role == "C" ||
                                                role == "CLA" ||
                                                role == "CH" ||
                                                role == "FR" ||
                                                role == "FO"
                                                    ? true
                                                    : false,
                                            "aria-labelledby": "username",
                                        }}
                                    ></CustomTextField>
                                </ListItem>
                            </List>

                            <List style={{ padding: 0 }}>
                                <ListItem>
                                    <Typography
                                        style={
                                            i18n.language === "en"
                                                ? { width: "3.8rem" }
                                                : { width: "3rem" }
                                        }
                                    >
                                        <InputLabel htmlFor="email">
                                            {t("common.email")}: &nbsp;
                                        </InputLabel>
                                    </Typography>
                                    <CustomTextField
                                        style={{ width: "40%" }}
                                        id="email"
                                        value={userEmail}
                                        inputProps={{
                                            readOnly: true,
                                            "aria-labelledby": "email",
                                        }}
                                    ></CustomTextField>
                                </ListItem>
                            </List>
                            {role !== "Public" && (
                                <List style={{ padding: 0 }}>
                                    <ListItem>
                                        <Typography
                                            style={
                                                i18n.language === "en"
                                                    ? { width: "3.8rem" }
                                                    : { width: "3rem" }
                                            }
                                        >
                                            <InputLabel htmlFor="post">
                                                {t("common.portal.post")}:
                                                &nbsp;
                                            </InputLabel>
                                        </Typography>

                                        <CustomTextField
                                            key={updated}
                                            style={{ width: "40%" }}
                                            defaultValue={post}
                                            onChange={(e) =>
                                                setPost(e.target.value)
                                            }
                                            id="post"
                                            inputProps={{
                                                readOnly:
                                                    role == "SA" ||
                                                    role == "E" ||
                                                    role == "C" ||
                                                    role == "CLA" ||
                                                    role == "CH" ||
                                                    role == "FR" ||
                                                    role == "FO"
                                                        ? true
                                                        : false,
                                                "aria-labelledby": "post",
                                            }}
                                        ></CustomTextField>
                                    </ListItem>
                                </List>
                            )}
                        </List>
                        <Divider
                            variant="middle"
                            style={{ marginLeft: "1rem" }}
                        />
                        <br />
                        {role != "C" &&
                            role != "E" &&
                            role != "SA" &&
                            role != "FR" &&
                            role != "FO" &&
                            role != "CLA" &&
                            role != "CH" && (
                                <Button
                                    style={{ marginLeft: "1rem" }}
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    onClick={onSubmit}
                                >
                                    {t("common.button.save")}
                                </Button>
                            )}
                        {role != "C" &&
                            role != "E" &&
                            role != "SA" &&
                            role != "FR" &&
                            role != "FO" &&
                            role != "CLA" &&
                            role != "CH" &&
                            showUnLinkButton && (
                                <Button
                                    style={{
                                        marginLeft: "1rem",
                                        textTransform: "unset",
                                    }}
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleYesOrNoDailogOpen}
                                >
                                    {t("common.button.unLinkIamSmart")}
                                </Button>
                            )}
                        {(role == "SA" ||
                            role == "SLA" ||
                            role == "SH" ||
                            role == "S") && (
                            <Button
                                style={{ marginLeft: "1rem" }}
                                className="buttons"
                                component={Link}
                                to="/changePassword"
                                variant="contained"
                                color="primary"
                            >
                                {t("common.portal.changePassword")}
                            </Button>
                        )}
                        <br />
                        {/* </Box> */}
                    </main>
                )}
            </Box>
            {isOpen ? <SavedDialog isOpen={isOpen} /> : null}
        </Container>
    );
}
export default ProfilePage;
